<template>
    <div class="profile-games">
        <el-row type="flex" justify="center">
            <!---------------------------->
            <!--  Search on system -->
            <!---------------------------->
            <el-col :xs="{span: 1}" :sm="{span: 2}">
                <div style="height: 1px;"></div>
            </el-col>

            <el-col :xs="{span: 21}" :sm="{span: 20}">
                <el-select
                        :class="'retro retro-search game-list-system-filter'"
                        :disabled="loadingSystems"
                        v-model="systemFilter"
                        filterable
                        multiple
                        :clearable="true"
                        @change="getGames"
                        placeholder="Filter systems">
                    <el-option
                            v-for="system in systems"
                            :key="system._id"
                            :label="system.name"
                            :value="system._id">
                        <span style="float: left"> <img :src="systemImages[system.avatar]" class="game-filter-system-avatar"></span>
                        <span style="float: left; color: #8492a6; font-size: 13px">{{ system.name }}</span>
                    </el-option>
                </el-select>
            </el-col>
        </el-row>

        <el-row type="flex" justify="center">
            <!---------------------------->
            <!--  Search on game title -->
            <!---------------------------->
            <el-col :xs="{span: 1}" :sm="{span: 2}">
                <div style="height: 1px;"></div>
            </el-col>

            <el-col :xs="{span: 21}" :sm="{span: 20}">
                <el-input
                        :placeholder="'Filter on game title'"
                        v-model="filter"
                        :clearable="true"
                        :class="'retro retro-search '"
                        :disabled="loading || loadingSystems"
                        @change="getGames"
                        @keyup.enter.native="getGames">
                    <i slot="prefix" class="el-input__icon el-icon-loading" v-show="loading"></i>
                </el-input>
            </el-col>
        </el-row>

        <!---------------------------->
        <!--  Fetched date -->
        <!---------------------------->
        <el-row style="margin-top: 1.5em;" type="flex" justify="left">
            <el-col :xs="{span: 1}" :sm="{span: 2}">
                <div style="height: 1px;"></div>
            </el-col>
            <el-col :xs="{span: 21}" :sm="{span: 20}">
                <el-row type="flex" justify="left" class="fetch-date">
                    <span style="text-align: left">
                        <p class="clickable" @click="refreshCache" v-if="systemsLastFetchedDate">
                            Updated {{ moment(systemsLastFetchedDate).fromNow() }}... <br>
                            Missing something? <span class="hidden-xs-only">Try to refresh</span><span class="hidden-sm-and-up">Refresh</span> <i class="el-icon-refresh" ></i><br>
                        </p>
                        <p v-else> List not fetched yet }} </p>
                    </span>

                </el-row>
            </el-col>
            <el-col :xs="{span: 2}" :sm="{span: 2}">
                <div style="height: 1px;"></div>
            </el-col>

        </el-row>

        <!---------------------------->
        <!--  Game matches -->
        <!---------------------------->
        <el-row type="flex" justify="center">
            <el-col :xs="{span: 24}" :sm="{span: 24}">
                <games-table :loading="loading || loadingSystems"
                             :done="done"
                             :infinityScroll="true"
                             :games="games"
                             :addGameEnabled="!!peak"
                             :isPeaking="!!peak"
                             :gameIcons="gameImages"
                             :getGames="getGames"
                             :systemIcons="systemImages"
                             :manageGameTagEnabled="!peak"
                             :removeGame="removeGame"
                             :refreshCacheOnGameEdit="!!(peak)"
                             :showBorders="true"
                             :onEmit="onEmit"
                             :sort="sort"
                             :sortable="true"
                             :user="user"
                             :sortBy="sortBy"
                             :order="order"
                             :options="{
                                showHeader: true,
                                tableWidth: {
                                    xs: 22,
                                    sm: 20
                                },
                                gameHeaderOptions: {
                                    prefix: { show: true, xs: 0, sm: 1 },
                                    spacing: { show: true, xs: 2, sm: 1 },
                                    postfix: { show: true, xs: 0, sm: 1 },
                                    system: { show: true, xs: 4, sm: 4 },
                                    name: { show: true, xs: 14, sm: 13 },
                                    status: { show: true, xs: 4, sm: 4 },
                                },
                                gameRowOptions: {
                                    index: { show: true, xs: 1, sm: 2 },
                                    systemIcon: { show: true, xs: 3, sm: 2  },
                                    systemShortName: { show: true, xs: 0, sm: 2  },
                                    gameIcon: { show: true, xs: 0, sm: 1  },
                                    gameTitle: { show: true, xs: 18, sm: 14  },
                                    gameTag: { show: true, xs: 2, sm: 3  },
                                }
                             }"
                ></games-table>
            </el-col>
        </el-row>
    </div>
</template>

<script>
// @ is an alias to /src
import chunkArray from '@/utils/chunk-array.js'
import MugenScroll from 'vue-mugen-scroll'

import GamesTable from '@/components/games-table'

import ErrorHandling from '@/utils/error-handling.js'
import Enumerate from '@/utils/enumerate.js'

import moment from 'moment'

export default {
  name: 'ProfileGames',
  components: {
    MugenScroll,
    GamesTable
  },
  props: ['user', 'mode', 'onEmit', 'peak'],
  mounted () {
    this.getUserSystems()

    if (this.mode === 'going2play') {
      this.titleNoGames = 'No pending games'
      this.descriptionNoGames = 'Their are currently no games pending to be played...!'
    } else if (this.mode === 'playing') {
      this.titleNoGames = 'No playing games'
      this.descriptionNoGames = 'You are not playing any game at the moment!'
    } else if (this.mode === 'finished') {
      this.titleNoGames = 'No finished games'
      this.descriptionNoGames = 'You have no games finished yet :)!'
    } else if (this.mode === 'played') {
      this.titleNoGames = 'No played games'
      this.descriptionNoGames = 'You have no games played and not finished!'
    }
  },
  data () {
    return {
      loading: false,
      titleNoGames: 'No games',
      descriptionNoGames: 'You have no games added to your list yet :)!',

      loadingSystems: false,
      systemsMap: [],
      systemFilter: [],
      systemFilterMap: {},
      currentSystemFilter: [],
      currentSystemFilterMap: {},

      systemImages: {},
      gameImages: {},
      done: false,
      skip: 0,

      currentFilter: '',
      filter: '',

      allGames: [],
      allGamesLastFetchedDate: false,
      matchedGames: [],
      games: [],
      systems: [],
      systemsLastFetchedDate: false,

      totalMatches: 0,

      currentSortBy: 'name',
      sortBy: 'name',

      currentOrder: 1,
      order: 1
    }
  },

  methods: {
    isEven (value) {
      return value % 2 === 0
    },

    to (name) {
      this.$router.push({ name: name })
    },

    chunkArray,
    moment,

    sort (type) {
      if (this.sortBy === type) {
        if (this.order === 1) this.order = -1
        else this.order = 1
      } else {
        this.sortBy = type
        this.order = 1
      }

      this.getGames()
    },

    async refreshCache () {
      this.$store.commit('systems', { [this.user._id]: false })
      this.$store.commit('games', { [this.user._id]: false })

      this.allGames = []
      this.matchedGames = []
      this.games = []
      this.systems = []

      await this.getUserSystems()
    },

    // ---------------------------------------
    // Endpoints 1/2 (Happy flow)
    // ---------------------------------------
    async getUserSystems () {
      let storeSystems = this.$store.state.systems[this.user._id]

      this.loadingSystems = true
      let res = {}
      if (!storeSystems) {
        res = await this.$http.get('systems', { params: { user: this.user._id } })
        this.systemsLastFetchedDate = new Date()
      }
      else {
        res.list = storeSystems.list
        this.systemsLastFetchedDate = storeSystems.fetchedDate
      }

      if (res.errors && res.errors.length) {
        ErrorHandling(res.errors, 'systems', { handleMessage: this.$message.error })
        this.loadingSystems = false
      } else {
        if (!storeSystems && res.done) this.$store.commit('systems', { [this.user._id]: { list: res.list, fetchedDate: new Date() } })

        for (let system of res.list) {
          this.systemsMap[system._id] = system

          if (this.systemImages[system.avatar]) continue
          this.systemImages[system.avatar] = require(`@/assets/${system.avatar}-mini.png`)
        }

        this.systems = res.list
        this.loadingSystems = false
        this.getUserGames()
      }
    },

    async getUserGames (batching = false) {
      if (!batching && (this.loading || this.loadingSystems)) {
        this.$message.error('Already loading, please wait!')
        return
      }
      this.loading = true

      if (!batching) {
        this.games = []
        this.allGames = []
      }

      let storedGames = this.$store.state.games[this.user._id]

      let res = {}
      if (!storedGames) {
        res = await this.$http.get('games', {
          params: {
            skip: this.skip,
            status: 'myGames',
            amount: 200,
            userToPeak: this.user._id,
            sort: 'name',
            order: 'name'
          }
        })
        this.allGamesLastFetchedDate = new Date()
      } else {
        res.list = storedGames.list
        this.allGamesLastFetchedDate = storedGames.fetchedDate
      }

      if (res.errors && res.errors.length) {
        ErrorHandling(res.errors, 'profileGames', { handleMessage: this.$message.error })
        this.loading = false
        return
      }

      for (let game of res.list) {
        if (game.avatar && !this.gameImages[game.avatar]) {
          this.gameImages[game.avatar] = require(`@/assets/icon-${game.avatar}.png`)
        }

        if (this.systemImages[game.systemAvatar]) continue
        this.systemImages[game.systemAvatar] = require(`@/assets/${game.systemAvatar}-mini.png`)
      }

      this.allGames = this.allGames.concat(res.list)
      if (!storedGames && !res.done) {
        this.skip = res.skip
        await this.getUserGames(true)
      } else {
        this.skip = 0
        this.$store.commit('games', { [this.user._id]: { list: this.allGames, fetchedDate: new Date() } })
        this.loading = false
        this.totalMatches = res.total
        this.getGames()
      }
    },

    getGames () {
      if (this.loading || this.loadingSystems) {
        this.$message.error('Already loading, please wait!')
        return
      }

      if (!this.allGames.length) {
        this.done = true
        return
      }

      this.loading = true

      let sameFilter = this.currentFilter === this.filter
      let sameSortBy = this.currentSortBy === this.sortBy
      let sameOrder = this.currentOrder === this.order
      let sameSystemFilter = true

      this.systemFilterMap = {}
      if (this.systemFilter.length !== this.currentSystemFilter.length) sameSystemFilter = false

      for (let system of this.systemFilter) {
        this.systemFilterMap[system] = 1
        if (!this.currentSystemFilterMap[system]) sameSystemFilter = false
      }

      if (sameSystemFilter) {
        for (let system of this.currentSystemFilter) {
          if (!this.systemFilterMap[system]) sameSystemFilter = false
        }
      }

      // If filter or order is changed, create new matchedGames array
      if (!this.matchedGames.length || !sameFilter || !sameSystemFilter || !sameSortBy || !sameOrder) {
        if (!this.matchedGames.length || !sameFilter || !sameSystemFilter) {
          this.matchedGames = []
          const matchAll = this.mode === 'myGames'
          const matchPlayed = this.mode === 'played'
          const matchFinished = this.mode === 'finished'
          const matchGoingToPlay = this.mode === 'going2play'
          const matchPlaying = ['playing', 'paused'].includes(this.mode)
          const matchPaused = ['playing', 'paused'].includes(this.mode)

          for (let game of this.allGames) {

            let filterMatch = !this.filter
            let systemFilterMatch = !this.systemFilter.length

            let modeMatch = matchAll
            if (!modeMatch && matchPlayed) modeMatch = game.status.labels.includes('played')
            if (!modeMatch && matchFinished) modeMatch = game.status.labels.includes('finished')
            if (!modeMatch && matchGoingToPlay) modeMatch = game.status.labels.includes('going2play')
            if (!modeMatch && matchPlaying) modeMatch = game.status.labels.includes('playing') || game.status.labels.includes('paused')
            if (!modeMatch && matchPaused) modeMatch = game.status.labels.includes('paused')

            if (!filterMatch) {
              const filterText = this.filter.trim().toLowerCase()
              const gameTitle = game.title.trim().toLowerCase()

              filterMatch = gameTitle.includes(filterText)
            }

            if (!systemFilterMatch) {
              systemFilterMatch = this.systemFilterMap[game.system]
            }

            if (filterMatch && systemFilterMatch && modeMatch) this.matchedGames.push(game)
          }
        }

        if (!sameSortBy || !sameOrder) {
          if (this.sortBy === 'name' && this.order === 1) this.matchedGames.sort(function (a, b) { return ('' + a.title).localeCompare(b.title) })
          if (this.sortBy === 'name' && this.order === -1) this.matchedGames.sort(function (a, b) { return ('' + b.title).localeCompare(a.title) })

          if (this.sortBy === 'system' && this.order === 1) this.matchedGames.sort(function (a, b) { return ('' + a.systemSlug).localeCompare(b.systemSlug) })
          if (this.sortBy === 'system' && this.order === -1) this.matchedGames.sort(function (a, b) { return ('' + b.systemSlug).localeCompare(a.systemSlug) })

          if (this.sortBy === 'status' && this.order === 1) this.matchedGames.sort(function (a, b) { return ('' + a.status.labels[0]).localeCompare(b.status.labels[0]) })
          if (this.sortBy === 'status' && this.order === -1) this.matchedGames.sort(function (a, b) { return ('' + b.status.labels[0]).localeCompare(a.status.labels[0]) })
        }

        this.games = []
      }

      const pointer = this.games.length - 1
      const max = (pointer - 1) + 30

      for (let [index, game] of Enumerate(this.matchedGames)) {

        if (index <= pointer) continue
        if (index > max) continue

        this.games.push(game)
      }

      if (this.games.length >= this.matchedGames.length) {
        this.done = true
      } else {
        this.done = false
      }

      this.loading = false

      this.currentFilter = this.filter
      this.currentSystemFilter = this.systemFilter
      this.currentSystemFilterMap = {}

      for (let system of this.systemFilter) {
        this.currentSystemFilterMap[system] = 1
      }

      this.currentSortBy = this.sortBy
      this.currentOrder = this.order
    },

    removeGame (game) {
      if (!game) return
      this.matchedGames = this.matchedGames.filter(el => el._id !== game._id)
      this.games = this.games.filter(el => el._id !== game._id)
      this.allGames = this.allGames.filter(el => el._id !== game._id)

      this.$store.commit('games', { [this.user._id]: this.allGames })
    }
  }
}
</script>

<style lang="scss">
@import '../styles/variables.scss';

.profile-games {
    .el-select__input {
        color: $main-color-2;
    }

    .filter-element {
        margin-bottom: 7px;
        text-align: left;
    }

    .matched-results {
        text-shadow: #2d00ff 1px 0 10px;
    }

    .no-matched-results {
        text-shadow: #ff0000 1px 0 10px;
    }

    .game-title-filter {
        text-shadow: #2d00ff 1px 0 10px;
    }

    .grayed-filter {
        color: #c6bfbf;
    }

    .fetch-date {
        font-size: $font-size-small-regular;
    }

    .filter-header {
        font-size: $font-size-regular;
    }

    .game-list-system-filter {
        margin-bottom: 1em;

        .el-input__inner {
            border-left-width: 1px;
        }

        .el-tag.el-tag--info {
            color: purple;
            font-size: $font-size-small;
            padding: 1px;
            padding-left: 3px;
            padding-right: 5px;
        }

        .el-tag .el-icon-close {
            margin-left: -6px;
            color: purple;
        }
    }

    .game-list-filters-results{
        /*border-bottom-style: solid;*/
        /*border-bottom-width: 3px;*/
        /*border-bottom-color: black;*/

        font-size: $font-size-small;

        .current-system-tag {
            font-size: $font-size-small;
            color: purple;
        }
    }

    .retro.el-button--primary{
        margin-top: 1em;
        width: 50%;
    }

    .game-list-filters-results {
        font-size: $font-size-small;
    }

    .no-games-match {
        margin-top: 50px;
        text-align: left;
        max-width: 500px;
    }

    .retro-search {
        width: 50%;
    }

    .retro .el-input__inner {
        border-left-width: 1px;
    }

    @media screen and (max-width: 35em) {
        .filter-header {
            font-size: $font-size-small;
        }
    }

    @media screen and (max-width: 61em) {
        .retro-search {
            width: 90%;
        }

        .retro.el-button--primary{
            margin-top: 1em;
            width: 90%;
        }

        .el-divider__text.is-center {
            font-size: 20px;
        }
    }
}
</style>
